import SvgInset from '@/components/SvgInset';
import { CDN_URL_ICONS } from '@/configs';
import React from 'react';

type Props = {};

export const IcKeyRight = (props: Props) => {
  return <SvgInset size={16} svgUrl={`${CDN_URL_ICONS}/ic-keyRight.svg`} />;
};
